import React from 'react';
import IllustrationState from '.';
import FailedImage from '../../../assets/icon/illustrations_error_cloudy.svg';
import EmptyIcon from '../../../assets/icon/illustrations_no-document.svg';
import { Image } from '@mantine/core';
import { IllustrationProps } from './SuccessIllustration';

const NoData: React.FC<IllustrationProps> = ({
  withoutImage,
  description = 'Failed to load data',
  title = 'Failed',
  titleSize,
  descriptionSize,
  span,
  theme,
  w,
  h
}) => {
  return (
    <>
      <IllustrationState
        Illustration={<Image src={EmptyIcon} w={w} h={h} />}
        description={description}
        title={title}
        titleColor={theme?.colors?.text}
        titleSize={titleSize}
        descriptionSize={descriptionSize}
        descriptionColor={theme?.colors?.text}
        isIlustration={!withoutImage}
        span={span}
      />
    </>
  );
};

export default NoData;
